import { Theme } from "@mui/material/styles";
import rgba from "assets/theme/functions/rgba";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    height: "100%",
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    alignItems: "flex-start",
    overflow: "auto",
  },
  warningTitle: {
    fontWeight: theme.typography.fontWeightMedium,
    marginBottom: theme.spacing.spacing4,
  },
  detailsArticle: {
    marginBottom: theme.spacing.spacing6,
  },
  detailsTitle: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.size.sm,
    marginBottom: theme.spacing.spacing2,
  },
  youTubeContainer: {
    display: "flex",
    width: theme.width.full,
    justifyContent: "center",
    marginBottom: theme.spacing.spacing4,
  },
  iframeClassName: {
    borderRadius: theme.borders.borderRadius.lg,
    width: theme.width.full,
  },
  content: {
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
    whiteSpace: "pre-line",
    paddingBottom: theme.spacing.spacing10,
  },
  descriptionBoxContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: rgba(theme.palette.white.main, 0.5),
    borderRadius: theme.borders.borderRadius.lg,
    padding: `${theme.spacing.spacing8} ${theme.spacing.spacing10}`,
    height: '100%',
  },
  descriptionBoxContainerLeumit: {
    justifyContent: "flex-start",
    gap: theme.spacing.spacing4,
    background: (theme.palette.background as any).softAlt,
    borderRadius: theme.borders.borderRadius.xl,
    padding: `${theme.spacing.spacing6} ${theme.spacing.spacing8}`,
    textAlign: "start",
    marginBottom: theme.spacing.spacing6,
    height: '100%',
  },
  descriptionBoxAlertIcon: {
    flexShrink: 0,
    width: 18,
    height: 18,
    "& path": {
      fill: theme.palette.extraColors?.alert,
    },
  },
  descriptionBoxAlertText: {
    color: theme.palette.extraColors?.alert,
    fontSize: theme.typography.size.sm,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: "20px",
  },
});
